import { useEffect, useRef, useState } from "react";
import {
  mostraAlertaError,
  mostraAlertaOk,
  mostraAlertaWarning,
} from "../../../../componentes/alerts/sweetAlert";
import { AxiosImagen, AxiosPrivado } from "../../../../componentes/axios/Axios";
import GestionUbicacion from "../../../../componentes/googlemap/GestionUbicacion";
import VerUbicacion from "../../../../componentes/googlemap/VerUbicacion";
import ModalBootstrap from "../../../../componentes/modal/ModalBootstrap";
import {
  ClienteImagenEditar,
  ClienteListar,
  ClientesEditar,
  ImagenCliente
} from "../../../../configuracion/apiUrls";
import { DireccionConfig } from "../../../../configuracion/Empresa";
import {
  regexEmail,
  regexIdentidad,
  regexNombreVacio,
  regexRTN,
  regexTelefono,
  regexNombreOpcionalValido,
  regexNombreValido,
  limpiarCamposVacios
} from "../../../../configuracion/validaciones";

const ModalClientesEmpleados = ({ datos, token, setListaClientes, ActualizarLista }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  console.log(datos);
  const [nuevaDireccion, setNuevaDireccion] = useState({
    direccion: DireccionConfig.direccion,
    longitud: DireccionConfig.longitud,
    latitud: DireccionConfig.latitud,
  });
  const [seleccionarDireccion, setSeleccionarDireccion] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formularioClientes, setFormularioClientes] = useState({
    id: datos ? datos.id : null,
    correo: datos ? datos.correo : "",
    rtn: datos ? datos.rtn : "",
    identidad: datos ? datos.identidad : "",
    primerNombre: datos
      ? datos.primerNombre
      : "",
    segundoNombre: datos
      ? datos.segundoNombre
      : "",
    primerApellido: datos
      ? datos.primerApellido
      : "",
    segundoApellido: datos
      ? datos.segundoApellido
      : "",
    telefonos: datos
      ? datos.ClienteTelefonos
      : [{ telefono: "" }],
    direcciones: datos
      ? datos.ClienteDireccions
      : [{ direccion: "", longitud: null, latitud: null }],
    empresas: datos
      ? datos.ClienteEmpresas
      : [{ nombre: "", rtn: "" }],
    genero: datos ? datos.genero : "",
    activo: true,
    imagen: datos
      ? datos.imagen
      : "clientes.jpeg",
    tipoUsuario: "Cliente",
  });

  const generos = [
    { value: 1, label: "Masculino" },
    { value: 2, label: "Femenino" },
  ];

  const [urlImagen, setUrlImagen] = useState(ImagenCliente + "clientes.jpeg");
  const [errorRtn, setErrorRtn] = useState(false);
  const [errorIdentidad, setErrorIdentidad] = useState(false);
  const [errorPrimerNombre, setErrorPrimerNombre] = useState(false);
  const [errorSegundoNombre, setErrorSegundoNombre] = useState(false);
  const [errorPrimerApellido, setErrorPrimerApellido] = useState(false);
  const [errorSegundoApellido, setErrorSegundoApellido] = useState(false);
  const [errorCorreo, setErrorCorreo] = useState(false);
  const [errorTelefonos, setErrorTelefonos] = useState([]);
  const [errorEmpresas, setErrorEmpresas] = useState([]);
  
  useEffect(() => {
    if (seleccionarDireccion) {
      setIsModalOpen(false);
      console.log(formularioClientes.direcciones.length);
      setFormularioClientes((prevState) => ({
        ...prevState,
        direcciones: [...prevState.direcciones, nuevaDireccion],
      }));
      setSeleccionarDireccion(false);
    }
  }, [seleccionarDireccion]);

  useEffect(() => {
    setErrorCorreo(!regexEmail.test(formularioClientes.correo));
    setErrorPrimerNombre(!regexNombreValido.test(formularioClientes.primerNombre));
    setErrorPrimerApellido(!regexNombreValido.test(formularioClientes.primerApellido));

    if (formularioClientes.primerNombre.length < 3) {
      setErrorPrimerNombre(true);
    } else {
      setErrorPrimerNombre(false);
    }

    if (formularioClientes.primerApellido.length < 3) {
      setErrorPrimerApellido(true);
    } else {
      setErrorPrimerApellido(false);
    }
    const segundoNombre = formularioClientes.segundoNombre || '';
    if (segundoNombre.trim()) {
      setErrorSegundoNombre(
        !regexNombreOpcionalValido.test(segundoNombre)
      );
    } else {
      setErrorSegundoNombre(false);
    }

    const segundoApellido = formularioClientes.segundoApellido || '';
    if (segundoApellido.trim()) {
      setErrorSegundoApellido(
        !regexNombreOpcionalValido.test(segundoApellido)
      );
    } else {
      setErrorSegundoApellido(false);
    }

    if (formularioClientes.rtn) {
      setErrorRtn(!regexRTN.test(formularioClientes.rtn));
    } else {
      setErrorRtn(false);
    }
    if (formularioClientes.identidad) {
      setErrorIdentidad(!regexIdentidad.test(formularioClientes.identidad));
    } else {
      setErrorIdentidad(false);
    }
    const nuevosErrores = formularioClientes.telefonos.map((numero) =>
      !regexTelefono.test(numero.telefono)
    );
    setErrorTelefonos(nuevosErrores);
    const nuevosErroresEmpresas = formularioClientes.empresas.map(empresa => {
      const nombreVacio = (empresa.nombre || '').trim() === "";
      const rtnVacio = (empresa.rtn || '').trim() === "";

      // 1. Inconsistencia (uno lleno y el otro vacío)
      const inconsistencia = (nombreVacio !== rtnVacio);

      // 2. Validación de formato de RTN (si no está vacío)
      const rtnInvalido = !rtnVacio && !regexRTN.test(empresa.rtn || '');

      // 3. Validación de formato de Nombre (si no está vacío, usando regexNombreValido)
      const nombreInvalido = !nombreVacio && !regexNombreValido.test(empresa.nombre || '');

      // Retorna true si hay AL MENOS un error
      return inconsistencia || rtnInvalido || nombreInvalido;
    });
    setErrorEmpresas(nuevosErroresEmpresas);
  }, [formularioClientes]);

  // Estado para el género seleccionado en el Select
  const [generoId, setGeneroId] = useState(
    datos
      ? generos.find((opcion) => opcion.label === datos.genero)
        ?.value || null
      : null
  );

  // Efecto para sincronizar el género en formularioClientes
  useEffect(() => {
    const genero = generoId
      ? generos.find((opcion) => opcion.value === generoId)?.label
      : "";
    setFormularioClientes((prevState) => ({
      ...prevState,
      genero: genero,
    }));
  }, [generoId]);

  useEffect(() => {
    if (modalIsOpen) {
      setFormularioClientes({
        id: datos ? datos.id : null,
        correo: datos ? datos.correo : "",
        rtn: datos ? datos.rtn : "",
        identidad: datos ? datos.identidad : "",
        primerNombre: datos
          ? datos.primerNombre
          : "",
        segundoNombre: datos
          ? datos.segundoNombre
          : "",
        primerApellido: datos
          ? datos.primerApellido
          : "",
        segundoApellido: datos
          ? datos.segundoApellido
          : "",
        telefonos: datos
          ? datos.ClienteTelefonos
          : [{ telefono: "" }],
        direcciones: datos
          ? datos.ClienteDireccions
          : [{ direccion: "", longitud: null, latitud: null }],
        empresas: datos
          ? datos.ClienteEmpresas
          : [{ nombre: "", rtn: "" }],
        genero: datos ? datos.genero : "",
        activo: true,
        imagen: datos
          ? datos.imagen
          : "clientes.jpeg",
        tipoUsuario: "Cliente",
      });
    }
  }, [modalIsOpen]);

  const manejadorClientes = (event) => {
    setFormularioClientes({
      ...formularioClientes,
      [event.target.name]: event.target.value,
    });
  };

  const manejarCambioNumeros = (index, value) => {
    const nuevosNumeros = [...formularioClientes.telefonos];
    nuevosNumeros[index] = { telefono: value };

    setFormularioClientes({
      ...formularioClientes,
      telefonos: nuevosNumeros,
    });
  };

  const agregarNumero = () => {
    setFormularioClientes((prevState) => ({
      ...prevState,
      telefonos: [...prevState.telefonos, { telefono: "" }],
    }));
  };

  const eliminarNumero = (index) => {
    setFormularioClientes((prevState) => {
      const nuevosNumeros = [...prevState.telefonos];
      nuevosNumeros.splice(index, 1);
      return { ...prevState, telefonos: nuevosNumeros };
    });
  };

  const eliminarDireccion = (index) => {
    setFormularioClientes((prevState) => {
      const nuevasDirecciones = [...prevState.direcciones];
      nuevasDirecciones.splice(index, 1);
      return { ...prevState, direcciones: nuevasDirecciones };
    });
  };

  const manejarCambioEmpresas = (index, name, value) => {
    const nuevasEmpresas = [...formularioClientes.empresas];
    nuevasEmpresas[index][name] = value;
    setFormularioClientes({
      ...formularioClientes,
      empresas: nuevasEmpresas,
    });
  };

  const agregarEmpresa = () => {
    setFormularioClientes((prevState) => ({
      ...prevState,
      empresas: [...prevState.empresas, { nombre: "", rtn: "" }],
    }));
  };

  const eliminarEmpresa = (index) => {
    setFormularioClientes((prevState) => {
      const nuevasEmpresas = [...prevState.empresas];
      nuevasEmpresas.splice(index, 1);
      return { ...prevState, empresas: nuevasEmpresas };
    });
  };

  const BotonEditar = () => {
    return (
      <button type="button" className="btn btn-warning text-white" onClick={editarCliente}>
        Editar
        <i className="fas fa-edit mx-2" />
      </button>
    );
  };

  const editarCliente = () => {

    const hayErrorTelefonos = errorTelefonos.some(e => e);
    const hayErrorEmpresas = errorEmpresas.some(e => e);

    if (
      errorPrimerNombre ||
      errorSegundoNombre ||
      errorPrimerApellido ||
      errorSegundoApellido ||
      errorIdentidad ||
      errorCorreo ||
      errorRtn ||
      errorIdentidad ||
      hayErrorTelefonos ||
      hayErrorEmpresas
    ) {
      mostraAlertaWarning("Existen errores en la introducción de campos");
      return;
    } else {
      // 2. Filtrado estricto: Solo incluimos empresas si AL MENOS uno de sus campos (nombre o rtn) tiene datos.
      const empresasValidas = formularioClientes.empresas.filter(empresa =>
        (empresa.nombre || '').trim() !== "" || (empresa.rtn || '').trim() !== ""
      );

      const formularioConEmpresasFiltradas = {
        ...formularioClientes,
        empresas: empresasValidas
      };
      const limpios = limpiarCamposVacios(formularioConEmpresasFiltradas, ['rtn', 'identidad', 'segundoNombre', 'segundoApellido']);
      try {
        AxiosPrivado.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${token}`;
        AxiosPrivado.put(
          ClientesEditar + formularioClientes.id,
          limpios
        )
          .then((respuesta) => {
            mostraAlertaOk("Registro actualizado correctamente");
            setModalIsOpen(false);
            ActualizarLista(ClienteListar, setListaClientes);
          })
          .catch((er) => {
            console.log(er);
            let msjError = "";
            switch (er.response.status) {
              case 400:
                if (er.response.data && Array.isArray(er.response.data)) {
                  er.response.data.forEach((f) => {
                    msjError += f.msg + ". ";
                  });
                } else {
                  msjError = er.response.data.error;
                }
                break;
              case 500:
                msjError = er.response.data.error;
                break;
              default:
                msjError = "Ocurrió un error desconocido.";
                break;
            }
            mostraAlertaError(msjError, "error");
          });
      } catch (error) {
        mostraAlertaError("Error en la pedición");
      }
    }
  };
  const handleFileChange = async (event) => {
    const fileObj = event.target.files && event.target.files[0];
    if (!fileObj) {
      return;
    } else {
      try {
        let formData = new FormData();
        formData.append("imagen", event.target.files[0]);
        await AxiosImagen.put(
          ClienteImagenEditar + formularioClientes.id,
          formData
        )
          .then((respuesta) => {
            setFormularioClientes((prevState) => ({
              ...prevState,
              imagen: respuesta.data.imagen,
            }));
            mostraAlertaOk("Imagen actualizada correctamente");
          })
          .catch((er) => {
            const { response } = er;
            const msjError =
              response?.data?.msj ||
              response?.data?.error?.message ||
              "Ocurrió un error desconocido.";
            mostraAlertaError(msjError, "error");
          });
      } catch (error) {
        console.log(error);
        mostraAlertaError("Error al actualizar la imagen");
      }
    }
  };

  const SeleccionarImagen = () => {
    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  const inputRef = useRef(null);

  //console.log(formularioClientes);

  return (
    <ModalBootstrap
      titulo="Editar Perfil"
      estiloBoton="btn btn-outline-primary"
      iconBoton="fas fa-edit mx-0"
      pie={<BotonEditar />}
      modalIsOpen={modalIsOpen}
      setModalIsOpen={setModalIsOpen}
    >
      <div className="row">
        <div className="col-sm-4 col-lg-2">
          <div className="form-group">
            <div className="text-center">
              <img
                className="product-image"
                src={ImagenCliente + formularioClientes.imagen}
                alt="Foto"
                crossOrigin="anonymous"
              />
            </div>
            <input
              type="file"
              style={{ display: "none" }}
              ref={inputRef}
              onChange={handleFileChange}
            />
            <button
              type="button"
              className="btn btn-block btn-outline-info btn-xs"
              onClick={SeleccionarImagen}
            >
              Actualizar
            </button>
          </div>
        </div>

        <div className="col-sm-8 col-lg-5">
          <div className="form-group">
            <label htmlFor="rtn">RTN</label>
            <input
              type="text"
              className={`form-control ${errorRtn ? "is-invalid" : ""}`}
              id="rtn"
              placeholder="Ingrese el rtn"
              name="rtn"
              value={formularioClientes.rtn}
              onChange={manejadorClientes}
            />
            {errorRtn && (
              <div className="invalid-feedback">
                El RTN debe tener exactamente 14 dígitos.
              </div>
            )}
          </div>
        </div>
        <div className="col-sm-8 col-lg-5">
          <div className="form-group">
            <label htmlFor="identidad">Identidad</label>
            <input
              type="text"
              className={`form-control ${errorIdentidad ? "is-invalid" : ""}`}
              id="identidad"
              placeholder="Ingrese la identidad"
              name="identidad"
              value={formularioClientes.identidad}
              onChange={manejadorClientes}
            />
            {errorIdentidad && (
              <div className="invalid-feedback">
                La identidad debe tener exactamente 13 dígitos.
              </div>
            )}
          </div>
        </div>
        <div className="col-sm-12 col-lg-5">
          <div className="form-group">
            <label htmlFor="correo">Correo</label>
            <input
              type="text"
              className={`form-control ${errorCorreo ? "is-invalid" : ""}`}
              id="correo"
              placeholder="Ingrese el correo"
              name="correo"
              value={formularioClientes.correo}
              onChange={manejadorClientes}
            />
            {errorCorreo && (
              <div className="invalid-feedback">
                Correo electrónico inválido
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-3 col-sm-6">
          <div className="form-group">
            <label htmlFor="primerNombre">Primer nombre</label>
            <input
              type="text"
              className={`form-control ${errorPrimerNombre ? "is-invalid" : ""
                }`}
              id="primerNombre"
              placeholder="Primer Nombre"
              name="primerNombre"
              value={formularioClientes.primerNombre}
              onChange={manejadorClientes}
            />
            {errorPrimerNombre && (
              <div className="invalid-feedback">
                El primer nombre debe tener al menos 3 caracteres (se permiten tildes).
              </div>
            )}
          </div>
        </div>

        <div className="col-lg-3 col-sm-6">
          <div className="form-group">
            <label htmlFor="segundoNombre">Segundo nombre</label>
            <input
              type="text"
              className={`form-control ${errorSegundoNombre ? "is-invalid" : ""
                }`}
              id="segundoNombre"
              placeholder="Segundo Nombre"
              name="segundoNombre"
              value={formularioClientes.segundoNombre}
              onChange={manejadorClientes}
            />
            {errorSegundoNombre && (
              <div className="invalid-feedback">
                El segundo nombre debe tener al menos 3 caracteres (se permiten tildes).
              </div>
            )}
          </div>
        </div>
        <div className="col-lg-3 col-sm-6">
          <div className="form-group">
            <label htmlFor="primerApellido">Primer apellido</label>
            <input
              type="text"
              className={`form-control ${errorPrimerApellido ? "is-invalid" : ""
                }`}
              id="primerApellido"
              placeholder="Primer Apellido"
              name="primerApellido"
              value={formularioClientes.primerApellido}
              onChange={manejadorClientes}
            />
            {errorPrimerApellido && (
              <div className="invalid-feedback">
                El primer apellido debe tener al menos 3 caracteres (se permiten tildes).
              </div>
            )}
          </div>
        </div>
        <div className="col-lg-3 col-sm-6">
          <div className="form-group">
            <label htmlFor="segundoApellido">Segundo apellido</label>
            <input
              type="text"
              className={`form-control ${errorSegundoApellido ? "is-invalid" : ""
                }`}
              id="segundoApellido"
              placeholder="Segundo Apellido"
              name="segundoApellido"
              value={formularioClientes.segundoApellido}
              onChange={manejadorClientes}
            />
            {errorSegundoApellido && (
              <div className="invalid-feedback">
                El segundo apellido debe tener al menos 3 caracteres (se permiten tildes).
              </div>
            )}
          </div>
        </div>
      </div>
      {/*Numeros de telefonos */}
      <div className="row">
        <div className="col-sm-12 col-md-6">
          <label>Teléfonos</label>
          <div className="row">
            <div className="col-sm-9">
              <div className="form-group">
                {formularioClientes.telefonos.map((numero, index) => (
                  <div key={index} className="input-group mb-3">
                    <input
                      type="text"
                      className={`form-control ${errorTelefonos[index] ? "is-invalid" : ""}`}
                      name="telefono"
                      value={numero.telefono}
                      onChange={(event) =>
                        manejarCambioNumeros(index, event.target.value)
                      }
                    />
                    {formularioClientes.telefonos.length > 1 && (
                      <button
                        type="button"
                        className="btn btn-danger mx-2"
                        onClick={() => eliminarNumero(index)}
                        width="20px"
                      >
                        <i className="fa fa-minus" aria-hidden="true"></i>
                      </button>
                    )}
                    {errorTelefonos[index] && (
                      <div className="invalid-feedback">
                        Número inválido. Debe tener entre 8 y 12 dígitos.
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
            <div className="col-sm-3">
              <button
                type="button"
                className="btn btn-primary"
                onClick={agregarNumero}
              >
                <i className="fa fa-plus" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">Datos de la empresas</h5>
        <div>
          <button
            type="button"
            className="btn btn-primary"
            onClick={agregarEmpresa}
          >
            <i className="fa fa-plus" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <hr className="mt-0"></hr>
      <div className="row">
        {formularioClientes.empresas && formularioClientes.empresas.map((empresa, index) => (
          <div key={index} className="col-12 d-flex align-items-center mb-3">
            <div className="col-lg-5 col-sm-12">
              <div className="form-group mb-0">
                <input
                  type="text"
                  className={`form-control ${errorEmpresas[index] ? "is-invalid" : ""}`}
                  placeholder="Nombre de la empresa"
                  name="nombre"
                  value={empresa.nombre || ''}
                  onChange={(e) =>
                    manejarCambioEmpresas(index, "nombre", e.target.value)
                  }
                />
                {(empresa.nombre || '').trim() !== "" && (empresa.rtn || '').trim() === "" && (
                  <div className="invalid-feedback d-block">
                    Debe ingresar el RTN si especifica el nombre de la empresa.
                  </div>
                )}
                {(empresa.nombre || '').trim() !== "" && !regexNombreValido.test(empresa.nombre) && (
                  <div className="invalid-feedback d-block">
                    El nombre debe tener un mínimo de 3 caracteres (se permiten tildes).
                  </div>
                )}
              </div>
            </div>
            <div className="col-lg-5 col-sm-12">
              <div className="form-group mb-0">
                <input
                  type="text"
                  className={`form-control ${errorEmpresas[index] ? "is-invalid" : ""}`}
                  placeholder="RTN de la empresa"
                  name="rtn"
                  value={empresa.rtn || ''}
                  onChange={(e) =>
                    manejarCambioEmpresas(index, "rtn", e.target.value)
                  }
                />
                {(empresa.rtn || '').trim() !== "" && (empresa.nombre || '').trim() === "" && (
                  <div className="invalid-feedback d-block">
                    Debe ingresar el nombre de la empresa si especifica el RTN.
                  </div>
                )}
                {(empresa.rtn || '').trim() !== "" && !regexRTN.test(empresa.rtn) && (
                  <div className="invalid-feedback d-block">
                    El RTN debe tener exactamente 14 dígitos numéricos.
                  </div>
                )}
              </div>
            </div>
            {formularioClientes.empresas.length > 1 && (
              <button
                type="button"
                className="btn btn-danger ms-2"
                onClick={() => eliminarEmpresa(index)}
              >
                <i className="fa fa-minus" aria-hidden="true"></i>
              </button>
            )}
          </div>
        ))}
      </div>
      {/*Direcciones */}
      <div className="row">
        <div className="col-12">
          <label>Direcciones</label>
          <div className="pb-3">
            <GestionUbicacion
              direccion={nuevaDireccion}
              setDireccion={setNuevaDireccion}
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              setSeleccionarDireccion={setSeleccionarDireccion}
              textoBoton={"Agregar Ubicación"}
              verdireccion={false}
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="form-group">
            {formularioClientes.direcciones.map((f, index) => (
              <div key={index} className="row">
                <div className="col-9">
                  <p className="text-muted">{f.direccion}</p>
                </div>
                <div className="col-3">
                  <VerUbicacion key={index} direccion={f} />
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => eliminarDireccion(index)}
                  >
                    <i className="fa fa-minus" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-4">
          <div className="form-group">
            <label htmlFor="genero">Genero</label>
            <select
              className="form-control select2bs4"
              style={{ width: "100%" }}
              value={generoId || ""}
              onChange={(e) => {
                setGeneroId(e.target.value);
              }}
            >
              <option value="">Seleccione un género</option>
              {generos.map((genero) => (
                <option key={genero.value} value={genero.value}>
                  {genero.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </ModalBootstrap>
  );
};
export default ModalClientesEmpleados;